import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TextGamesSharedModule } from '@games/games-shared/text-games-shared.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { FitTextModule, FormFieldModule, TextsFilterComponent } from '@shared/components/games';
import { NgxMaskDirective } from 'ngx-mask';
import { SlipMatricesControllerComponent } from './slip-matrices-controller/slip-matrices-controller.component';
import { SlipMatricesCorrectAnswerPreviewComponent } from './slip-matrices-preview/slip-matrices-answer-preview/slip-matrices-answer-preview.component';
import { SlipMatricesExamplePreviewComponent } from './slip-matrices-preview/slip-matrices-example-preview/slip-matrices-example-preview.component';
import { SlipMatricesParametersPreviewComponent } from './slip-matrices-preview/slip-matrices-parameters-preview/slip-matrices-parameters-preview.component';
import { SlipMatricesUserAnswerPreviewComponent } from './slip-matrices-preview/slip-matrices-user-answer-preview/slip-matrices-user-answer-preview.component';
import { SlipMatricesSettingsComponent } from './slip-matrices-settings/slip-matrices-settings.component';
import { MatTooltip } from '@angular/material/tooltip';
import { MatError } from '@angular/material/input';

@NgModule({
  declarations: [
    SlipMatricesControllerComponent,
    SlipMatricesSettingsComponent,
    SlipMatricesCorrectAnswerPreviewComponent,
    SlipMatricesExamplePreviewComponent,
    SlipMatricesParametersPreviewComponent,
    SlipMatricesUserAnswerPreviewComponent,
  ],
  exports: [
    SlipMatricesControllerComponent,
    SlipMatricesSettingsComponent,
    SlipMatricesCorrectAnswerPreviewComponent,
    SlipMatricesExamplePreviewComponent,
    SlipMatricesParametersPreviewComponent,
    SlipMatricesUserAnswerPreviewComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    FitTextModule,
    NgSelectModule,
    TextsFilterComponent,
    NgxMaskDirective,
    TextGamesSharedModule,
    MatTooltip,
    FormFieldModule,
    MatError,
  ],
})
export class SlipMatricesModule {}
